<template>
  <div class="flex h-full min-h-0">
    <div class="cm-subnav">
      <button
        v-for="sub in subPages"
        :key="sub.key"
        class="cm-subnav-btn"
        :class="{ active: subPage === sub.key }"
        @click="subPage = sub.key"
      >{{ sub.label }}</button>
    </div>
    <div class="flex-1 min-w-0 min-h-0 flex flex-col">
      <div v-if="loading" class="cm-loading flex-1">
        <div class="cm-spinner"></div>
      </div>
      <div v-else-if="!configured" class="cm-empty flex-1">
        <div class="ico"><font-awesome-icon :icon="['fas', 'hospital']" /></div>
        <div class="msg">
          Utilization Management is not configured for this tenant.
          Run seed_um_program and seed_um_sats to set it up.
        </div>
      </div>
      <template v-else>
        <UM_Board v-if="subPage === 'board'" :config="config" />
        <UM_Ledger v-if="subPage === 'ledger'" />
      </template>
    </div>
  </div>
</template>

<script>
import '@/assets/cm-tokens.css';
import UM_Board from '@/components/Care_Management/UM_Board.vue';
import UM_Ledger from '@/components/Care_Management/UM_Ledger.vue';

export default {
  name: 'CareManagementUM',
  components: { UM_Board, UM_Ledger },
  data() {
    return {
      loading: true,
      config: null,
      subPage: 'board',
      subPages: [
        { key: 'board', label: 'Board' },
        { key: 'ledger', label: 'Decision Ledger' },
      ],
    };
  },
  computed: {
    configured() {
      return !!this.config?.configured;
    },
  },
  mounted() {
    this.loadConfig();
  },
  methods: {
    async loadConfig() {
      this.loading = true;
      try {
        const { data } = await this.$axios.get('/api/care-management/um/config/');
        this.config = data;
      } catch (e) {
        console.error('Error loading UM config:', e);
        this.config = { configured: false };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
